import { render, staticRenderFns } from "./CardBusiness.vue?vue&type=template&id=0db0dd24&"
import script from "./CardBusiness.vue?vue&type=script&lang=js&"
export * from "./CardBusiness.vue?vue&type=script&lang=js&"
import style0 from "./CardBusiness.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports